import { supabase } from '../lib/supabase'
import type { ComercialCupom } from '../types/comercial'

export const comercialService = {
  async listCupons(): Promise<ComercialCupom[]> {
    const pageSize = 1000
    let page = 0
    let hasMore = true
    const allRows: ComercialCupom[] = []

    while (hasMore) {
      const from = page * pageSize
      const to = from + pageSize - 1
      const { data, error } = await supabase
        .from('dashcorretor_coupons')
        .select(
          'id, code, discount_type, value, valid_until, used_at, used_by, used_notes, broker_id, creation_reason, created_at, updated_at, broker:brokers(id, name, id_scgp, classification)'
        )
        .order('created_at', { ascending: false })
        .range(from, to)

      if (error) throw error

      const batch = (data || []) as any as ComercialCupom[]
      allRows.push(...batch)

      if (batch.length < pageSize) {
        hasMore = false
      } else {
        page += 1
      }
    }

    return allRows
  },

  async listAvailableCuponsByBrokerId(brokerId: string): Promise<ComercialCupom[]> {
    if (!brokerId) return []

    const { data, error } = await supabase
      .from('dashcorretor_coupons')
      .select(
        'id, code, discount_type, value, valid_until, used_at, used_by, used_notes, broker_id, creation_reason, created_at, updated_at'
      )
      .eq('broker_id', brokerId)
      .is('used_at', null)
      .order('valid_until', { ascending: true, nullsFirst: false })
      .order('created_at', { ascending: false })

    if (error) throw error
    return (data || []) as ComercialCupom[]
  },

  async listCuponsByBrokerId(brokerId: string): Promise<ComercialCupom[]> {
    if (!brokerId) return []

    const pageSize = 1000
    let page = 0
    let hasMore = true
    const allRows: ComercialCupom[] = []

    while (hasMore) {
      const from = page * pageSize
      const to = from + pageSize - 1
      const { data, error } = await supabase
        .from('dashcorretor_coupons')
        .select(
          'id, code, discount_type, value, valid_until, used_at, used_by, used_notes, broker_id, creation_reason, created_at, updated_at'
        )
        .eq('broker_id', brokerId)
        .order('valid_until', { ascending: true, nullsFirst: false })
        .order('created_at', { ascending: false })
        .range(from, to)

      if (error) throw error

      const batch = (data || []) as ComercialCupom[]
      allRows.push(...batch)

      if (batch.length < pageSize) {
        hasMore = false
      } else {
        page += 1
      }
    }

    return allRows
  },

  async darBaixaCupom(id: string, observacao?: string | null): Promise<void> {
    const { data: { user } } = await supabase.auth.getUser()
    const { error } = await supabase
      .from('dashcorretor_coupons')
      .update({
        used_at: new Date().toISOString(),
        used_by: user?.id ?? null,
        used_notes: observacao?.trim() || null,
      })
      .eq('id', id)
    if (error) throw error
  },
}
